export default __webpack_public_path__ + "static/media/Itinerary-Icon.b25b6ee6.svg";